import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmHideSectionModal = ({ show, onConfirm, onCancel, sectionTitle }) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Hide Section</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        You are hiding this section. It will be hidden from every product.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Hide Section
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmHideSectionModal;

